"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _makeStyles = _interopRequireDefault(require("../styles/makeStyles"));

var _styles = _interopRequireDefault(require("./styles"));

var _excluded = ["className", "Component"];
var useStyles = (0, _makeStyles["default"])(_styles["default"]);

var getPassThroughProps = function getPassThroughProps(props) {
  return Object.keys(props).filter(function (key) {
    return !key.startsWith('margin') && !key.startsWith('padding');
  }).reduce(function (passThroughProps, key) {
    passThroughProps[key] = props[key];
    return passThroughProps;
  }, {});
};
/**
 * Component for responsive margins and padding
 */


var Spacing = function Spacing(_ref) {
  var classNameProp = _ref.className,
      Component = _ref.Component,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var classes = useStyles(props);
  return /*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({}, getPassThroughProps(props), {
    className: (0, _classnames["default"])(classes.root, classNameProp)
  }));
};

Spacing.propTypes = {
  /** The content of the component */
  children: _propTypes["default"].node,

  /** The DOM node or render function used to display */
  Component: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].string])
};
Spacing.defaultProps = {
  Component: 'div'
};
var _default = Spacing;
exports["default"] = _default;